import { render, staticRenderFns } from "./PlanningMarket.vue?vue&type=template&id=4ac6124c&"
import script from "./PlanningMarket.vue?vue&type=script&lang=js&"
export * from "./PlanningMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports